// extracted by mini-css-extract-plugin
export var productImage = "_rs-1";
export var viewLink = "_rs-2";
export var wishlistItem = "_rs-0";